export default __webpack_public_path__ + "static/media/Delhi 1.eca78e74.svg";